<div class="layout-content">
	<div class="grid">
		<div class="col-12 flex flex-column align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
			<p-tag icon="pi cm-alert" [value]="('MFA_MAIL_WARNING' | translate)" severity="warning"></p-tag>
			<button *ngIf="resendEnable" type="button" pButton pRipple (click)="resendPin()" label="{{ 'RESEND_CODE' | translate }}"
				class="p-button-secondary font-normal" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
		<div class="col-12">
			<div class="flex align-items-center justify-content-center">
				<input class="custom-mfa-input p-2" [formControl]="pinValue" />
				<!--<div *ngFor="let p of display">
					<input class="custom-otp-input p-2"
						[class]="pin.length === pinLength ? 'border-bottom-2 border-primary' : ''" [value]="p"
						disabled="true" />
				</div>-->
			</div>

			<div class="flex align-items-center justify-content-center mt-5 w-full">
				<div class="card px-6 pb-7 flex flex-column border-1 border-gray-600"
					style="background-color: #54575C; border-radius: 35px;">
					<div class="flex flex-row align-items-center justify-content-center">
						<img src="./assets/images/logos/CAME-A_alpha_white_blue.png" alt="CAME Logo" class="w-7rem pb-3 pt-2">
					</div>
					<div class="card py-1 px-4 bg-blue-500 border-2 border-gray-600" style="border-radius: 10px;">
						<div class="grid mt-0 max-w-16rem">
							<div class="col-4 flex justify-content-center px-0 py-1" *ngFor="let btn of pinpadBtns">
								<button pButton pRipple label="{{btn}}" (click)="onKeyPressed(btn)"
									[class]="pinValue.value.length === pinLength ? 'bg-blue-900 text-0' : 'bg-bluegray-600 text-blue-200'"
									class="font-medium border-round-md text-5xl w-5rem h-3_5rem"
									[disabled]="pinValue.value.length === pinLength">
								</button>
							</div>
							<div class="col-4 flex justify-content-center px-0 py-1">
								<button pButton pRipple label="*" style="font-family: Roboto;" (click)="onClearPressed()"
									[class]="pinValue.value.length === 0 ? 'bg-blue-800' : 'bg-red-700'"
									class="font-semibold border-round-md text-900 text-5xl w-5rem h-3_5rem"
									[disabled]="pinValue.value.length === 0">
								</button>
							</div>
							<div class="col-4 flex justify-content-center px-0 py-1">
								<button pButton pRipple label="0" (click)="onKeyPressed(0)"
									[class]="pinValue.value.length === pinLength ? 'bg-blue-900 text-0' : 'bg-bluegray-600 text-blue-200'"
									class="font-medium border-round-md text-5xl w-5rem h-3_5rem"
									[disabled]="pinValue.value.length === pinLength">
								</button>
							</div>
							<div class="col-4 flex justify-content-center px-0 py-1">
								<button pButton pRipple label="#" style="font-family: Roboto;" (click)="onOkPressed()"
									[class]="pinValue.value.length !== pinLength ? 'bg-blue-800' : 'bg-green-700'"
									class="font-semibold border-round-md text-900 text-5xl w-5rem h-3_5rem"
									[disabled]="pinValue.value.length !== pinLength">
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>